import React from "react";
import Button from "@material-ui/core/Button";
import "./StorefrontActionButton.css";

const toneProps = {
  primary: { color: "primary", variant: "contained" },
  secondary: { color: "primary", variant: "outlined" },
  quiet: { color: "default", variant: "text" },
};

const StorefrontActionButton = React.forwardRef(
  ({ className = "", tone = "primary", ...props }, ref) => {
    const resolved = toneProps[tone] || toneProps.primary;
    return (
      <Button
        {...resolved}
        {...props}
        className={`storefront-action storefront-action--${tone} ${className}`.trim()}
        ref={ref}
      />
    );
  },
);

StorefrontActionButton.displayName = "StorefrontActionButton";

export default StorefrontActionButton;
